import * as React from "react";
import {Component} from "react";
import {Button, Input} from "reactstrap";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";


export const ApiKeyTypeLookerCC = "LOOKER_CC";
export const ApiKeyTypeDataNode = "DATA_NODE";

export class ApiKeyComponent extends Component {

    constructor(props) {
        super(props);

        this.handleGenerateApiKey = this.handleGenerateApiKey.bind(this);

        this.state = {
            apiKey: this.props.apiKey
        }
    }

    handleGenerateApiKey() {
        const url = this._getGenerateApiKeyURL();
        new APIClient(url).call('POST', {'key_type': this.props.keyType})
            .then((response) => {
                if (response.status === 'ERROR') {
                    alert(response['error_message']);
                } else if (response.status === 'OK') {
                    alert('La KEY se ha generado exitosamente.');
                    this.setState({apiKey: response.data.api_key});
                }
            }).catch((error) => {
            alert(error)
        })
    }

    _getGenerateApiKeyURL(){
        if (this.props.keyType === ApiKeyTypeDataNode)
            return API_URL + 'looker-cc/api_key/data-node';
        else
            return API_URL + 'looker-cc/api_key/looker-cc';
    }

    render() {
        if(this.state.apiKey)
            return this.renderApiKey();
        else
            return this.renderGenerateApiKey();
    }

    renderApiKey() {
        return <div className="form-row">
            <div className="form-col col-12 mb-3">
                <label>KEY:</label>
                <div className="input-group-append">
                    <Input name="apiKey" readOnly={true} type="text" value={this.state.apiKey} className="form-control mr-2"/>
                    {/*{this.renderTestButton()}*/}
                </div>
            </div>
        </div>;

    }

    renderGenerateApiKey() {
        return <Button key="button" className="btn btn-secondary" onClick={this.handleGenerateApiKey}
        style={{minWidth: "115px"}}>Generar KEY</Button>
    }
}
